<template>
    <div>
        <div v-for="(state, key) in reservations_by_states" :key="key">
            <div v-if="state.length > 0">
                <div class="mb-3 text-xl">{{ key }}</div>

                <Reservation
                    v-for="(reservation, key) in state"
                    :key="key"
                    :data="reservation"
                ></Reservation>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Reservation from "@/components/profile/ReservationEntry";

export default {
    name: "Reservations",
    computed: mapGetters({
        reservations_by_states: "profile/reservations/reservations_by_states"
    }),
    methods: mapActions({
        fetchReservations: "profile/reservations/fetchReservations"
    }),
    mounted() {
        this.fetchReservations();
    },
    components: { Reservation }
};
</script>

<style>
[data-view-type="profile"] .bb-view-background {
    background: var(--profile-background);
}
</style>
